import React from 'react';
import UnifiedHeader from './UnifiedHeader';
import logo from '../../logo/logo.svg';
import { REACT_APP_DOCS_URL } from '../../constants/config';

const Header = () => (
  <UnifiedHeader
    dashUrl={process.env.REACT_APP_DASH_URL || ''}
    mainUrl={process.env.REACT_APP_MAIN_SITE_URL || ''}
    docsUrl={REACT_APP_DOCS_URL}
    navbarLogo={
      <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
        <img src={logo} alt="Sophare AI Logo" style={{ width: '34px', height: '34px' }} />
        <span style={{ fontSize: '18px', fontWeight: 600, letterSpacing: '0.3px' }}>Sophare</span>
      </a>
    }
  />
);

export default Header;
